import React, { useState, useEffect } from 'react';
import ConversationTableCompleted from '../../../features/supervision/conversations/components/ConversationTable/Completed/ConversationTableCompleted';
import ConversationTableInProgress from '../../../features/supervision/conversations/components/ConversationTable/InProgress/ConversationTableInProgress';
import ConversationTableUpGoing from '../../../features/supervision/conversations/components/ConversationTable/UpGoing/ConversationTableUpGoing';
import { PageTable, Header } from '/src/layouts/page';
import { setStorageParamForCurrentCompany, getStorageParamForCurrentCompany } from '/src/utils/storageParamForCurrentCompany';
import { env } from '/src/var/env';
import SliderTab from '/src/components/slider/sliderTab';
import IconButton from '/src/components/UI/Button/IconButton/IconButton';
import { TabNameProvider } from '../../../hooks/tabNameContext';
import storage from "/src/utils/storage";
import ModalManager from "@ebay/nice-modal-react";
import ApiModal from "/src/components/modal/ApiModal/ApiModal";
import ConversationUpGoingService from '../../../features/supervision/conversations/services/ConversationUpGoingService';
import hasPermission from '/src/utils/hasPermission';

function ConversationList() {
    const company = storage('session').get('company');
    const { is_admin } = storage('local').get('user');
    const { deleteAllConversation } = ConversationUpGoingService;
    const [ refreshTableForce, setRefreshTableForce] = useState(false);
    const refreshList = () => {
        setItems([...items.map(item=>item)])
    }
    const getItems = ()=>{
        return [
            { name: 'Completed', component: <ConversationTableCompleted setRefreshList={refreshList}/>, type: 0 },
            { name: 'In progress', component: <ConversationTableInProgress setRefreshList={refreshList} />, type: 1 },
            { name: 'Upgoing', component: <ConversationTableUpGoing  setRefreshList={refreshList} resetList={refreshTableForce}/>, type: 2 }
        ]
    }

    const token = storage('local').get('token');
    //const [filterValues, setFilterValues] = useState(getStorageParamForCurrentCompany('conversation_filters') || {});
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [downloadUrl, setDownloadUrl] = useState('');

    const [items, setItems] = useState(getItems());

    useEffect(() => {
        const selectedTab = items[selectedIndex];
        const currentFilters = getStorageParamForCurrentCompany('conversation_filters');
        const url = new URL(`${env.REACT_APP_API_PATH}/export/conversations/xlsx`);
        url.searchParams.append('token_auth', token);
        url.searchParams.append('type', selectedTab.type);

        Object.keys(currentFilters).forEach(key => {
            if (currentFilters[key]) {
                if (Array.isArray(currentFilters[key])) {
                    url.searchParams.append(key, currentFilters[key].join(','));
                } else {
                    url.searchParams.append(key, currentFilters[key]);
                }
            }
        });

        url.searchParams.append('company', company.id);
        const decodedUrl = url.toString().replace(/%2C/g, ',');
        setDownloadUrl(decodedUrl);
    }, [selectedIndex, token, company]);

    const handleTabChange = (index) => {
        setSelectedIndex(index);
    };

    const deleteAction = async () => {

        ModalManager.show(ApiModal, {
            title : 'Delete all upgoing conversations from  ' + company.name,
            body: 'Do you really want to delete all upgoing conversations from the company ' + company.name + " ?",
            api : {
                request : deleteAllConversation,
                param : [company.id]
            },
            buttons : [
                {className : 'validate', label : 'Cancel'},
                {className : 'cancel', label : 'Delete', type : 'submit'},
            ],
            confirm : {
                name: company.name,
                fieldName: "your company",
            }
        }).then( ()=> {refreshForce()})
    }
    const refreshForce = () => {
        setItems(getItems().map((item, index) => {
            if (item.type === 2) {
              return {
                ...item,
                component: <ConversationTableUpGoing  setRefreshList={refreshList} resetList={!refreshTableForce}/>
              };
            }
            return item; 
          }));
        setRefreshTableForce(!refreshTableForce)
    }

    return (
        <TabNameProvider>
            <PageTable>
                <Header title={<span> List of Last Conversations from <span style={{ color: "var(--main)" }}>{company.name}</span></span>}>
                    <a href={downloadUrl} rel="noopener noreferrer">
                        <IconButton className="icons_up main-iconButton profil_action main_add-button space_tableButton" icon="fas fa-download" title="Export Conversations"></IconButton>
                    </a>
                    { (selectedIndex == 0) &&
                        <a href={downloadUrl+"&message=false"} rel="noopener noreferrer">
                            <IconButton className="icons_up main-iconButton profil_action main_add-button space_tableButton" icon="fas fa-file-zipper" title="Export Conversations without message"></IconButton>
                        </a>
                    }
                

                    { ((is_admin || hasPermission('delete_conversation')) && selectedIndex == 2) ? <IconButton onClick={deleteAction} className=" icons_up main-iconButton delete_action main_add-button space_tableButton red-button-action-bg_color" icon="fas fa-trash" title="Delete All Conversations Upgoing"/> : null} 
                </Header>
               <SliderTab items={items} name="conversations" type="table" onTabChange={handleTabChange} />
            </PageTable>
        </TabNameProvider>
    );
}

export default ConversationList;
